module.exports = __webpack_public_path__ + "static/media/plan-C2b-mobile-en.61d2a2f8.png";